import DeteriorationAlerts from './DeteriorationAlerts';

export default DeteriorationAlerts;
